import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import Overlay from '../../legos/Overlay';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { getDeviationTitle } from '../../../_helpers';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import PollOverlay from './PollOverlay';
import s from './PollThumb.scss';
const PollThumb = ({ className, deviation, height, responsive, style, width, extraActions })=>{
    const { showOverlay, __forceHoveredForStories } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement(HoverableWrapper, {
        className: classnames(s['root'], className),
        style: _object_spread({
            width,
            height
        }, style),
        __forceHoveredForStories: __forceHoveredForStories
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "PollThumb"
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive
    }), /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        className: s['link'],
        title: getDeviationTitle(deviation)
    }, /*#__PURE__*/ React.createElement("span", null)), showOverlay && /*#__PURE__*/ React.createElement(Overlay, {
        deviation: deviation,
        width: width,
        height: height,
        className: s['overlay'],
        extraActions: extraActions
    }, /*#__PURE__*/ React.createElement(PollOverlay, {
        className: s['poll-overlay'],
        deviation: deviation
    }))));
};
PollThumb.displayName = 'PollThumb';
export default PollThumb;
